import { Dispatch } from 'react';
import { Localizations } from '../../../localization/definitions/enums';

export interface LocalizationAction {
    type: LocalizationActionType;
    payload: Localizations;
}

export enum LocalizationActionType {
    CHANGE_LANGUAGE = 'CHANGE_LANGUAGE',
}

export const changeLanguage =
    (language: Localizations) =>
    async (dispatch: Dispatch<LocalizationAction>) => {
        dispatch({
            type: LocalizationActionType.CHANGE_LANGUAGE,
            payload: language,
        });
    };
